import { Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';


import { HttpService } from 'src/app/service/http.service';
import { SalesAgentWeeklyResult } from 'src/app/stats/sales-report/sales-agent-weekly-result';
import { SalesAgentTotalBookings } from './sales-agent-total-bookings';
import { SalesReportRecordThisYear } from './sales-report-record-this-year';
import { SalesReportService } from './sales-report.service';
import { WeekRecord } from './week-record';
import { MenuItem } from 'primeng/api/menuitem';
import { SalesReportRecord } from './sales-report-record';
import { SalesReportResult } from './sales-report-result';

@Component({
  selector: 'app-sales-report',
  templateUrl: './sales-report.component.html',
  styleUrls: ['./sales-report.component.css']
})
export class SalesReportComponent implements OnInit {


  items: MenuItem[] = [
    { label: "First", command: () => this.activeItemId = 1 },
    { label: "Second", command: () => this.activeItemId = 2 },
    { label: "Immersion", command: () => this.activeItemId = 3 },
    { label: "High School", command: () => this.activeItemId = 4 },
    { label: "English", command: () => this.activeItemId = 5 },
    { label: "Agents", command: () => this.activeItemId = 6 }
  ];
  activeItemId = 1;

  constructor(
    private httpService: HttpService,
    private salesReportService: SalesReportService
  ) { }

  ngOnInit(): void {
    let weekNums = this.getWeekNums();
    moment.updateLocale("en", {
      week: {
        dow: 1,
        doy: 4
      }
    });

    let monday = moment().startOf("week");
    let thisWeek = moment().isoWeek();
    this.salesReportService.thisWeekNum = thisWeek;
    this.salesReportService.mondayOfThisWeek = monday.format("DD/MM/YYYY");

    this.salesReportService.data = {
      labels: weekNums,
      datasets: [
        {
          label: this.salesReportService.thisYear,
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.4)"
        },
        {
          label: this.salesReportService.lastYear,
          data: [],
          backgroundColor: "rgba(30, 99, 255, 0.4)"
        }
      ]
    }
    this.httpService.getSalesReportResult().subscribe((res: SalesReportResult) => {
      this.salesReportService.result = res;
      let weekNums = this.getWeekNumsUntilLastWeek();
      this.salesReportService.setCumulativeBookingData(this.salesReportService.result.cumulativeBookingNumberThisYear, this.salesReportService.result.cumulativeBookingNumberLastYear);
      let lastWeek = moment().subtract(1, "weeks").isoWeek();
      this.salesReportService.lastWeekNum = lastWeek;
      this.setResultsOfLastWeek(lastWeek);
      this.getRecordsByAgentName(this.salesReportService.lastWeekNum);
      this.salesReportService.weekNums = weekNums;
      this.salesReportService.data.labels = weekNums;
      this.populateList();
    });
  }

  getWeekNumsUntilLastWeek() {
    let weekNums = [];
    let weekCounter = 1;
    for (let i = 0; i < this.salesReportService.result!.cumulativeBookingNumberThisYear.length; i++) {
      weekNums.push(weekCounter);
      weekCounter++;
    }
    return weekNums;
  }

  getRecordsByAgentName(weekNum: number) {
    let sortedArray = this.salesReportService.result!.records.sort((a, b) => {
      if (a.salesAgentName < b.salesAgentName) {
        return -1;
      }
      return 1;
    });
    let dataset: SalesReportRecord[][] = [];
    if (sortedArray.length > 0) {
      let previousAgent = sortedArray[0].salesAgentName;
      dataset.push([]);
      let agentCounter = 0;
      for (let i = 0; i < sortedArray.length; i++) {
        let record = sortedArray[i];
        if (record.salesAgentName != previousAgent) {
          dataset.push([]);
          previousAgent = record.salesAgentName;
          agentCounter++;
        }
        dataset[agentCounter].push(record);
      }
      let yearRecords = [];
      for (let data of dataset) {
        let newData = data.filter(record => record.year == this.salesReportService.thisYear && record.weekNum <= weekNum && record.weekNum != 0 && record.isActive);
        let dataLastyear = data.filter(record => record.year == this.salesReportService.lastYear && record.weekNum <= weekNum && record.weekNum != 0 && record.isActive);
        let weeksThisYear = 0;
        let weeksLastyear = 0;
        for (let record of data) {
          if (record.year == this.salesReportService.thisYear && record.weekNum <= weekNum && record.weekNum != 0 && record.isActive) {
            weeksThisYear += record.duration;
          } else if (record.year == this.salesReportService.lastYear && record.weekNum <= weekNum && record.weekNum != 0 && record.isActive) {
            weeksLastyear += record.duration;
          }
        }
        yearRecords.push(new SalesReportRecordThisYear(newData.length, weeksThisYear, dataLastyear.length, weeksLastyear, data[0].salesAgentName));
      }

      for (let data of dataset) {
        let agentName = data[0].salesAgentName;
        let newData = data.filter(record => record.year == this.salesReportService.thisYear && record.weekNum == weekNum);
        let dataLastyear = data.filter(record => record.year == this.salesReportService.lastYear && record.weekNum == weekNum);
        let weeksThisYear = 0;
        let weeksLastyear = 0;
        for (let record of data) {
          if (record.year == this.salesReportService.thisYear && record.weekNum == weekNum) {
            weeksThisYear += record.duration;
          } else if (record.year == this.salesReportService.lastYear && record.weekNum == weekNum) {
            weeksLastyear += record.duration;
          }
        }
        this.salesReportService.salesAgentsWeeklyResult.push(new SalesAgentWeeklyResult(
          agentName, newData.length, weeksThisYear, dataLastyear.length, weeksLastyear
        ));
      }

      let salesAgentsWithTotal = [];

      for (let data of dataset) {
        let thisYearCounter = data.filter(record => this.salesReportService.thisYear == record.year).length;
        let lastYearCounter = data.filter(record => this.salesReportService.lastYear == record.year).length;
        let twoYearsAgoCounter = data.filter(record => this.salesReportService.lastYear - 1 == record.year).length;
        let agentWithTotal = new SalesAgentTotalBookings(data[0].salesAgentName, thisYearCounter, lastYearCounter, twoYearsAgoCounter);
        salesAgentsWithTotal.push(agentWithTotal);
      }
      this.salesReportService.cumulativeWeeklyDataSet = yearRecords;
      this.salesReportService.salesAgentTotals = salesAgentsWithTotal;
    }

  }

  setResultsOfLastWeek(lastWeekNum: number) {
    this.salesReportService.lastWeekResultOfThisYear = this.salesReportService.result!.weeklyBookingNumberThisYear[lastWeekNum - 1];
    this.salesReportService.lastWeekResultOfLastYear = this.salesReportService.result!.weeklyBookingNumberLastYear[lastWeekNum - 1];
  }

  populateList() {
    for (let i = 0; i < this.salesReportService.result!.weeklyBookingNumberThisYear.length; i++) {
      this.salesReportService.numberRecordList.push(
        new WeekRecord(
          i + 1,
          this.salesReportService.result!.cumulativeBookingNumberThisYear[i],
          this.salesReportService.result!.cumulativeBookingNumberLastYear[i])
      );
      this.salesReportService.durationRecordList.push(new WeekRecord(
        i + 1,
        this.salesReportService.result!.cumulativeBookingDurationThisYear[i],
        this.salesReportService.result!.cumulativeBookingDurationLastYear[i]
      ));
    }
    this.salesReportService.weekRecordList = this.salesReportService.numberRecordList;
  }

  getWeekNums() {
    let weekNums = [];
    for (let i = 1; i < 54; i++) {
      weekNums.push(i);
    }
    return weekNums;
  }

  changeYear() {
    this.httpService.getStatsLineItems().subscribe(res => {
      this.salesReportService.lineItems = res;
    });
  }

}
